export default {
    公司制度文件:'相关文件',
    // desc:'对行业、上市公司研究的内容和方法进行全面的阐述和论证，对研究过程中所获取的资料进行全面系统的整理和分析形成的报告。'
}